import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import Device from './Device';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Button from '@material-ui/core/Button';
import { DeviceFormAdd } from './DeviceForm';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';

const Devices = () => {
  const [devices, setDevices] = useState([]);
  const [addDevice, setAddDevice] = useState(false);
  const history = useHistory();

  const fetchDevices = () => {
    fetch(process.env.REACT_APP_PROXY_HOST + '/liste/devices', { method: 'GET' })
      .then((res) => res.json())
      .then((data) => setDevices(data));
  };

  const handleEvent = (device, editMode) => {
    history.push({ pathname: '/device/' + device._id, deviceid: device._id, state: { device, editMode } });
  };

  const deleteDevice = (device) => {
    fetch(process.env.REACT_APP_PROXY_HOST + '/liste/devices/' + device._id, { method: 'DELETE' })
      .then(fetchDevices);
  };

  function hasCommit() {
    fetchDevices();
  }

  useEffect(() => {
    fetchDevices();
  }, []);

  return (
    <div>
      <h1>Appareils</h1>
      <List component="nav" aria-label="secondary mailbox folders">
        {devices.map((device) => (
          <ListItem button key={device._id} onClick={() => handleEvent(device, false)}>
            <ListItemText><Device _id={device._id} /></ListItemText>
            <ListItemSecondaryAction>
              <IconButton edge="end" aria-label="edit" onClick={() => handleEvent(device, true)}><EditIcon /></IconButton>
              <IconButton edge="end" aria-label="delete" onClick={() => deleteDevice(device)}><DeleteIcon /></IconButton>
            </ListItemSecondaryAction>
          </ListItem>
        ))}
      </List>
      <Button variant="contained" color="primary" onClick={() => setAddDevice(true)}>Ajouter</Button>
      {addDevice && (
        <div>
          <DeviceFormAdd devices={devices} hasCommit={hasCommit} />
          <Button variant="contained" color="secondary" onClick={() => setAddDevice(false)}>Annuler</Button>
        </div>
      )}
    </div>
  );
};

export default Devices;



// WEBPACK FOOTER //
// src/components/devices/Devices.js